import { useQuery } from '@apollo/client';
import { Empty } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ApplicantApplyToViewContainerApplicantUserDocument, ApplicantUserPersonalInformation } from '../../../../generated';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { ApplicantProfileApplyToView } from './applicant-profile-apply-to-view';

interface ApplicantProfileApplyToViewContainerProps {
  applicantId: string;
}

export const ApplicantProfileApplyToViewContainer: React.FC<ApplicantProfileApplyToViewContainerProps> = ({ applicantId }) => {
  const navigate = useNavigate();

  // Query to get the applicant's applying to data
  const {
    data: applyingToData,
    loading: applyingToLoading,
    error: applyingToError
  } = useQuery(ApplicantApplyToViewContainerApplicantUserDocument, {
    variables: {
      id: applicantId
    },
    context: {
      headers: {
        'cache-enabled': 'true'
      }
    }
  });

  const handleEditToggle = () => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]+$/, '/edit');
    navigate(newPath);
  };

  return (
    <ComponentQueryLoader
      loading={applyingToLoading}
      error={applyingToError}
      hasData={applyingToData}
      hasDataComponent={
        <ApplicantProfileApplyToView data={applyingToData?.applicantUser?.personalInformation as ApplicantUserPersonalInformation} onEditToggle={handleEditToggle} />
      }
      noDataComponent={<Empty description="No data available" />}
    />
  );
};
